import { FilterDrawerRadioGroup, MinimalSelect } from '@sphere/ui';
import useTranslation from 'next-translate/useTranslation';
import { useEffect, useState } from 'react';
import { SortOption, SortOptionType } from '../config';

type Props<T extends SortOptionType> = {
  sortOptions: SortOption<T>[];
  isDisabled?: boolean;
  onChange: (value: SortOption<T>) => void;
  value: SortOption<SortOptionType>;
  variant?: 'list' | 'select';
  title?: string;
};

const SortingOptions = <T extends SortOptionType>({
  sortOptions,
  isDisabled = false,
  onChange,
  value,
  variant,
  title,
}: Props<T>) => {
  const { t } = useTranslation('search');
  const [internalValue, setInternalValue] = useState<string>(value.label);

  const Component = variant === 'list' ? FilterDrawerRadioGroup : MinimalSelect;

  useEffect(() => {
    setInternalValue(value.label);
  }, [value]);

  useEffect(() => {
    const option = sortOptions.find(o => o.label === internalValue);
    if (!option || option.label === value.label) return;
    onChange(option);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [internalValue]);

  return (
    <Component
      value={internalValue}
      title={title}
      testId="sortingOptions"
      options={sortOptions.map(option => ({
        value: option.label,
        label: t(`sort.options.${option.label}`),
      }))}
      disabled={isDisabled}
      onChange={v => setInternalValue(v)}
    />
  );
};

export default SortingOptions;
